import { render, staticRenderFns } from "./portaldrawerDialog.vue?vue&type=template&id=389d9773&scoped=true&lang=pug"
import script from "./portaldrawerDialog.vue?vue&type=script&lang=js"
export * from "./portaldrawerDialog.vue?vue&type=script&lang=js"
import style0 from "./portaldrawerDialog.vue?vue&type=style&index=0&id=389d9773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d9773",
  null
  
)

export default component.exports